import React, {useEffect, useRef} from 'react';
import {usePrerenderPresentation} from '../utils/prerender';

// A shared poster and reserved dimensions keep the first frame stable. Video
// playback enhances the page after takeover, and is never needed for readiness.
export default function PrerenderVideo({autoPlay = true, ...props}) {
    const {ready} = usePrerenderPresentation();
    const ref = useRef(null);
    useEffect(() => {
        if (ready && autoPlay) ref.current?.play()?.catch(() => {});
    }, [ready, autoPlay]);
    return <video {...props} ref={ref} playsInline
                  autoPlay={ready && autoPlay} preload={ready ? 'metadata' : 'none'}/>;
}
